import api from '../../api/client';
import React from "react";
import StockManagementPage from "../../components/StockManagement";

const Inventory = () => {
  return (
    <React.Fragment>
      <StockManagementPage />
    </React.Fragment>
  );
};

export default Inventory;
